import React from 'react'
import classNames from 'classnames'

export type SearchableListProps = {
  items: []
  filterItems: (items: [], search: string) => []
  renderRow: (
    args: { item: any; selectionCallback: () => void }
  ) => React.ReactNode[]
  showItemsOnEmptyTerm?: boolean
  inputProps?: any
  itemsContainerProps?: any
}

export default function SearchableList({
  items,
  filterItems,
  renderRow,
  showItemsOnEmptyTerm = true,
  inputProps = {},
  itemsContainerProps = {},
}: SearchableListProps) {
  const [search, setSearch] = React.useState('')
  const clearSearch = React.useCallback(() => setSearch(''), [])

  const filter = React.useMemo(
    () => (items: [], search: string) => filterItems(items, search),
    [filterItems]
  )

  const displayedItems = filter(items, search)

  const { className, id = 'multi-select', ..._inputProps } = inputProps

  let placeholderContent = null
  if (displayedItems.length === 0 && (search || showItemsOnEmptyTerm)) {
    placeholderContent = (
      <div className="padding-left-medium padding-vertical-normal shade-20">
        No result
      </div>
    )
  }

  return (
    <React.Fragment>
      <div
        className="flexbox flexbox-align-center border-small border-shade-40 radius-normal position-relative"
        style={{ height: 36 }}
      >
        <input
          id={id}
          className={classNames(
            'background-transparent shade-05 border-none placeholder-shade-20 padding-horizontal-normal padding-vertical-normal height-full flexbox-grow font-size-normal radius-normal',
            className
          )}
          value={search}
          onChange={event => setSearch(event.target.value)}
          {..._inputProps}
        />
      </div>
      <div
        className="scrollable border-small border-top-none border-shade-40 radius-bottom-normal padding-vertical-smaller"
        {...itemsContainerProps}
      >
        {displayedItems.map(item =>
          renderRow({
            item,
            selectionCallback: clearSearch,
          })
        )}

        {placeholderContent}
      </div>
    </React.Fragment>
  )
}
